import setGlobalState from '../../../redux/setGlobalState';
import store from '../../../store';
import type {AiAgentUiAction, AiAgentUiActionPayload} from '../../../redux/aiAgent/aiAgent.type';
import {getPayloadIntent} from './agentSchema';
import {mergeCurrentFormValues} from './snapshotAgentFormValues';
import {
    createEventAndOpenForm,
    ensureNewEventFormOpen,
    isOtherIntentLocked,
    lockSessionIntent,
    openNavigatePopupIfNeeded,
    shouldSkipCreateEvent,
} from './agentUiActionOpeners';

export {isNewEventFormOpenInUi} from './agentUiActionOpeners';

type NavigateFn = (to: string | number, options?: {state?: unknown}) => void;

function storePendingFormFill(payload: AiAgentUiActionPayload | undefined): void {
    if(!payload?.formId || !payload.fields || !Object.keys(payload.fields).length) {
        return;
    }
    // Seat map is left for the user — do not auto-fill or remember as filled
    const fields = payload.formId === 'NEW_EVENT'
        ? Object.fromEntries(
            Object.entries(payload.fields).filter(([key]) => key !== 'map' && !key.startsWith('map.')),
        )
        : payload.fields;
    if(!Object.keys(fields).length) {
        return;
    }
    mergeCurrentFormValues(fields);
    setGlobalState('aiAgent.pendingFormFill', {formId: payload.formId, fields});
    if(store.getState().aiAgent?.activeFormId === payload.formId) {
        setGlobalState('ui.show.isOpenTickchakLoader', true);
    }
}

export async function applyAgentUiAction({
    uiAction,
    navigate,
    eid,
}: {
    uiAction: AiAgentUiAction;
    navigate: NavigateFn;
    eid?: number | null;
}): Promise<void> {
    // The server already isolates the locked session intent (enforceAgentGuards).
    const {type, payload} = uiAction;
    if(payload?.eventType) {
        setGlobalState('aiAgent.sessionEventType', payload.eventType);
    }
    const intent = getPayloadIntent(payload || {});
    if(intent && !isOtherIntentLocked(intent)) {
        lockSessionIntent(intent);
    }
    storePendingFormFill(payload);

    if(type !== 'OPEN_UI') {
        openNavigatePopupIfNeeded(payload, navigate, eid);
    }
    if(type === 'FILL_FORM') {
        await ensureNewEventFormOpen(payload, navigate);
        return;
    }
    if((type === 'OPEN_UI' || type === 'NONE') && payload?.eventType && !shouldSkipCreateEvent()) {
        await createEventAndOpenForm(payload.eventType, navigate);
    }
}
